import * as React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";

type Props = {
    actionLink?: {
        disabled?: boolean;
        label: React.ReactNode;
        onClick: () => void;
    };
    className?: string;
    containerClassName?: string;
    description: React.ReactNode;
    showIcon?: boolean;
    title?: React.ReactNode;
};

const InfoBanner: React.FC<Props> = ({
    actionLink,
    className,
    containerClassName,
    description,
    showIcon = true,
    title,
}) => {
    const resolvedContainerClassName = containerClassName
        ? `app-modal__info-container ${containerClassName}`
        : "app-modal__info-container";
    const resolvedClassName = className
        ? `app-modal__info-banner ${className}`
        : "app-modal__info-banner";

    return (
        <div className={resolvedContainerClassName}>
            <div className={resolvedClassName}>
                {showIcon ? (
                    <InfoCircleOutlined className="app-modal__info-icon info-circle-icon" />
                ) : null}
                <div className="app-modal__info-content">
                    {title ? (
                        <div className="app-modal__info-title">{title}</div>
                    ) : null}
                    <div className="app-modal__info-text">{description}</div>
                </div>
                {actionLink ? (
                    <Button
                        className="app-modal__info-action"
                        type="link"
                        disabled={actionLink.disabled}
                        onClick={actionLink.onClick}
                    >
                        {actionLink.label}
                    </Button>
                ) : null}
            </div>
        </div>
    );
};

export default InfoBanner;
